import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { useAuthState } from "../../../../../../../Helper/Context";
export const ViewScheduling = (props) => {

  const { DataObj, IsDashPost, setIsDashPost } = props

  const dispatch = useDispatch()
  const userDetails = useAuthState();
  const { UserID, token, UserFullName, RoleID } = userDetails

  const {

    PlanationDetailsCountdata,
    YearValue,
    MonthValue,
    ZoneValue,
    DashSelect,
    Language,

  } = DataObj


  const { t } = useTranslation()

  const navigate = useNavigate();

  const [CreateSchedulingPopUpShow, setCreateSchedulingPopUpShow] = useState(false)

  const handleCreateScheduling = () => {
    setCreateSchedulingPopUpShow(!CreateSchedulingPopUpShow)
  }

  const [IsPost, setIsPost] = useState(false)

  const handleIsPost = () => {
    setIsPost(!IsPost)
    setIsDashPost(!IsDashPost)
    setCreateSchedulingPopUpShow(false)
  }

  const [ZoneHeaderData, setZoneHeaderData] = useState([])
  const [ZoneHeaderID, setZoneHeaderID] = useState(sessionStorage.getItem("ZoneHeaderID") ? sessionStorage.getItem("ZoneHeaderID") : '0')
  const [ZoneHeaderLable, seZoneHeaderLable] = useState(sessionStorage.getItem("ZoneHeaderLable") ? sessionStorage.getItem("ZoneHeaderLable") : '')
  const [Countdata, setCountdata] = useState({})

  const handleZoneDDL = (i) => {
    setZoneHeaderID(i.m_ZoneID);
    seZoneHeaderLable(i.zoneName)
    sessionStorage.setItem("ZoneHeaderID", i.m_ZoneID);
    sessionStorage.setItem("ZoneHeaderLable", i.zoneName);

  }


  useEffect(() => {
    const data = {
      UserID: UserID,
      Lanaguage: Language,
      Flag: 'UserWiseZone',
      token: token,
      HeaderFlag: 'HeaderFlag',
      setZoneHeaderData: setZoneHeaderData,
    }
  }, [Language])

  const { DDLData } = useSelector(state => state.ZoneNameDDLData)

  useEffect(() => {
    const data = {
      M_FinancialYearID: DataObj?.YearValue,
      M_MonthID: DataObj?.MonthValue,
      M_ZoneID: ZoneHeaderID,
      M_WorkTypeID: DataObj?.DashSelect,
      Flag: "WEB_Scheduling",
      M_UserID: UserID,
      token: token,
      handleGetCount: handleGetCount
    }

  }, [DataObj.YearValue, DataObj.MonthValue, DataObj.ZoneValue, ZoneHeaderID])

  const handleGetCount = (data) => {
    let tempData = {}
    data.forEach((item) => {
      tempData[item.paramName] = item.totalCount
    })
    setCountdata(tempData)
  }

  return (
    <div className="row m-1 mt-3 " >

      <div className="col-12 col-lg-12  bg-white rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
        <div className="row pt-2">
          {/* Create Scheduling */}
          <div className="col-12 col-md-6 col-lg-3 pt-3 pb-3 pb-lg-0">
            <h5 className=" fw-bold fs-5 all_heading_fontsize">{t('EncroachmentDashboard.ViewScheduling')}</h5>
          </div>

          {
            RoleID == 6 &&
            <div className="col-12 col-md-6 col-lg-4 pt-3 pb-0 px-0 ps-3 ps-lg-0">
              <span className="CreateScheduling_button"
                onClick={() => {
                  handleCreateScheduling()
                }}
              >
                <i class="fa-solid fa-plus"></i> {t('EncroachmentDashboard.CreateScheduling')}
              </span>

            </div>
          }
      
          <div className={RoleID != 6 ? 'col-12 col-md-12 col-lg-8 mx-auto pt-2' : "col-12 col-md-12 col-lg-12 mx-auto pt-2"}>
            <span className="card-headerbtnhor font-weight-bold py-3 ">
              <ul className="nav nav-tabs float-end me-lg-3 mb-md-2 mr-2 border">
                <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                  {
                    RoleID == 6 || RoleID == 10 ?
                      <></>
                      :
                      <button
                        type="button"
                        className={ZoneHeaderID == "0" ? "active btn text-dark border-gray text-white" : "text-black  btn border-gray"}
                        onClick={() => setZoneHeaderID("0")}
                      >{t('EncroachmentDashboard.Total')}</button>
                  }


                  {
                    (RoleID != 6) &&
                    ZoneHeaderData && ZoneHeaderData.table && ZoneHeaderData.table.length > 0 &&
                    ZoneHeaderData.table.map((i) => {
                      return (
                        <button type="button"
                          className={ZoneHeaderID == i?.m_ZoneID ? "active btn text-dark border-gray text-white" : "text-black  btn border-gray"}
                          onClick={() => (handleZoneDDL(i))}
                        >{i?.zoneName}
                        </button>
                      )
                    })
                  }

                </div>
              </ul>
            </span>
          </div>


          {/* Total Scheduling */}
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 pb-3 cursor-pointer rounded_eic"
            onClick={() => navigate(`/SchedulingGrids?ScreenNameTotal=Total Scheduling&Flag=TotalScheduling&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}
          >
            <div className="p-4 background_style border" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row">
                <div className="col-9">
                  <h6 className=" text-dark" style={{ whiteSpace: 'nowrap' }}>{t('EncroachmentDashboard.TotalScheduling')}</h6>
                  <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.TotalScheduling ? Countdata.TotalScheduling.toFixed(0) : '0'}</h2>
                </div>
                <div className="col-3 d-flex align-items-center justify-content-center pt-3 ">
                  <img src="./assets/img/eic_img/Total_Scheduling.png" style={{ width: '40px' }} alt="" srcset="" />
                </div>
              </div>
            </div>
          </div>


          {/* Upcoming Scheduling */}
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 pb-3 cursor-pointer rounded_eic"
            onClick={() => navigate(`/SchedulingGrids?ScreenNameTotal=Upcoming Scheduling&Flag=UpcomingScheduling&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}
          >
            <div className="p-4 background_style border" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row">
                <div className="col-9">
                  <h6 className=" text-dark" style={{ whiteSpace: 'nowrap' }}>{t('EncroachmentDashboard.UpcomingScheduling')}</h6>
                  <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.UpcomingScheduling ? Countdata.UpcomingScheduling.toFixed(0) : '0'}</h2>
                </div>
                <div className="col-3 d-flex align-items-center justify-content-center pt-3 ">
                  <img src="./assets/img/eic_img/Upcoming_Scheduling.png" style={{ width: '40px' }} alt="" srcset="" />
                </div>
              </div>
            </div>
          </div>


          {/* Completed Scheduling */}
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 pb-3 cursor-pointer rounded_eic"
            onClick={() => navigate(`/SchedulingGrids?ScreenNameTotal=Completed Scheduling&Flag=CompletedScheduling&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}
          >
            <div className="p-4 background_style border" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row">
                <div className="col-9">
                  <h6 className="text-dark" style={{ whiteSpace: 'nowrap' }}>{t('EncroachmentDashboard.CompletedScheduling')}</h6>
                  <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.CompletedScheduling ? Countdata.CompletedScheduling.toFixed(0) : '0'}</h2>
                </div>
                <div className="col-3 d-flex align-items-center justify-content-center pt-3 ">
                  <img src="./assets/img/eic_img/Past_Scheduling.png" style={{ width: '40px' }} alt="" srcset="" />
                </div>
              </div>
            </div>

          </div>

          {/* --------------------- Pending Scheduling ----------------- */}

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 pb-3 cursor-pointer rounded_eic"
            onClick={() => navigate(`/SchedulingGrids?ScreenNameTotal=Pending Scheduling&Flag=PendingScheduling&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}
          >
            <div className="p-4 background_style border" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row">
                <div className="col-9">
                  <h6 className="text-dark" style={{ whiteSpace: 'nowrap' }}>{t('EncroachmentDashboard.PendingScheduling')}</h6>
                  <h2 className="pt-2 fw-bold text-danger"> 0</h2>
                </div>
                <div className="col-3 d-flex align-items-center justify-content-center pt-3 ">
                  <img src="./assets/img/eic_img/Past_Scheduling.png" style={{ width: '40px' }} alt="" srcset="" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
     

    </div>


  )
}